import React from "react"

import SmallButton from "../../../toolkits/SmallButton/SmallButton"
import CustomPopup from "../../../toolkits/CustomPopup/CustomPopup"

import {SUCCESS_CODE, ERROR_CODE} from "../../../constants/other"

import {useDeleteEquipmentCategoryMutation} from "../../../api/equipment"


const DeleteCategoryPopup = ({category, setUserMessage, refreshTable, close}) => {
    const [deleteEquipmentCategory] = useDeleteEquipmentCategoryMutation()

    const handleSubmit = () => {

        deleteEquipmentCategory(category.id)
            .unwrap()
            .then(() => {
                refreshTable()
                close()
                setUserMessage({message: "Equipment Category was successfully deleted!", code: SUCCESS_CODE})
            })
            .catch(error => {
                close()
                setUserMessage({message: error.response.data.message, code: ERROR_CODE})
            })
    }

    return (
        <CustomPopup text_title={`Do you want to delete "${category.name}"?`} isSubtitle isAgreePopup>
            <div className="popup-bottom">
                <div className="popup-bottom-button-container">
                    <SmallButton btnType="secondary" onClick={close}> CANCEL </SmallButton>
                    <SmallButton onClick={handleSubmit}> DELETE </SmallButton>
                </div>
            </div>
        </CustomPopup>
    )
}

export default DeleteCategoryPopup
